import React from 'react';
import ReactECharts from "@/components/EChartsReact";
import moment from 'moment';
import { CHART_COLORS } from './chartColors';

const ClassName_Savings_MonthlyCost = 'ChartsClassName-Savings-MonthlyCost';

export const config = {
    title: 'Monthly Cost Savings',
    className: ClassName_Savings_MonthlyCost
}

export const MonthlyCostSavingsChart = ({ data }) => {

    // 处理数据，分离电力和燃气数据
    const gasData = data
        .filter(item => item.type === 'Gas')
        .map(item => [item.date, item.value]);
    
    const electricityData = data
        .filter(item => item.type === 'Electricity')
        // 移除重复数据
        .filter((item, index, self) => 
            index === self.findIndex(t => t.date === item.date)
        )
        .map(item => [item.date, item.value]);

    // 计算Y轴范围
    const allValues = [...gasData, ...electricityData].map(item => item[1]);
    const minValue = Math.min(...allValues);
    const maxValue = Math.max(...allValues);
    const range = maxValue - minValue;
    const padding = range * 0.1;
    const yMin = Math.floor((minValue - padding) / 1000) * 1000;
    const yMax = Math.ceil((maxValue + padding) / 1000) * 1000;

    const option = {
        title: {
            text: config.title,
            left: '1%',
            top: '2%',
            textStyle: {
                color: CHART_COLORS.title,
                fontSize: 14
            }
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'none'
            },
            formatter: function(params) {
                // 获取日期信息
                const dateValue = params[0].axisValue || params[0].name || params[0].data[0];
                const monthHeader = `<div style="margin-bottom: 5px;"><b>Month: ${moment(dateValue).format('MMM YYYY')}</b></div>`;
                
                const content = params.map(param => {
                    const formattedValue = `$${Math.round(param.value[1]).toLocaleString()}`;
                    const color = param.seriesName === 'Gas' ? CHART_COLORS.gas : CHART_COLORS.electricity;
                    const marker = `<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;background-color:${color};"></span>`;
                    return `${marker}${param.seriesName}: ${formattedValue}`;
                }).join('<br/>');
                return monthHeader + content;
            }
        },
        legend: {
            data: ['Gas', 'Electricity'],
            top: '10%',
            itemWidth: 10,
            itemHeight: 10
        },
        grid: {
            left: '1%',
            right: '2%',
            bottom: '1%',
            top: '20%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                boundaryGap: true,
                data: [...new Set(data.map(item => item.date))],
                axisLabel: {
                    rotate: 50,
                    formatter: function(value) {
                        return moment(value).format('MMM');
                    }
                },
                position: 'bottom'
            },
            {
                type: 'category',
                position: 'top',
                boundaryGap: true,
                axisLine: {
                    show: true
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    formatter: function(value) {
                        return moment(value).format('YYYY');
                    }
                },
                data: [...new Set(data.map(item => item.date))]
            }
        ],
        yAxis: {
            type: 'value',
            name: 'Cost ($)',
            nameLocation: 'middle',
            nameGap: 200,
            nameTextStyle: {
                fontWeight: 'bold',
                color: CHART_COLORS.axisLabel
            },
            axisLine: {
                show: true
            },
            min: yMin,
            max: yMax,
            interval: (yMax - yMin) / 5,
            axisLabel: {
                formatter: function(value) {
                    const absValue = Math.abs(value);
                    if (absValue >= 1000) {
                        return `$${value < 0 ? '-' : ''}${Math.round(absValue / 1000)}K`;
                    }
                    return `$${value}`;
                }
            }
        },
        series: [
            {
                name: 'Gas',
                type: 'line',
                data: gasData,
                symbolSize: 8,
                symbol: 'circle',
                itemStyle: {
                    borderWidth: 2,
                    borderColor: CHART_COLORS.gas,
                    color: '#fff'
                },
                lineStyle: {
                    width: 2,
                    color: CHART_COLORS.gas
                },
            },
            {
                name: 'Electricity',
                type: 'line',
                data: electricityData,
                symbolSize: 8,
                symbol: 'circle',
                itemStyle: {
                    borderWidth: 2,
                    borderColor: CHART_COLORS.electricity,
                    color: '#fff'
                },
                lineStyle: {
                    width: 2,
                    color: CHART_COLORS.electricity
                },
            }
        ]
    };

    return (
        <ReactECharts
            className={config.className}
            option={option}
            style={{ height: '100%', width: '100%' }}
        />
    );
}